export default {
    panelGroupLoading: false,
    panelGroupsListLoading: false,
    panelGroupsList: [],
    panelGroupsPosLoading: false,
    panelGroupsPosition: [],
}